import VanillaTilt from 'vanilla-tilt'
import '@js/app'
import scrollbar from '@js/scrollbar'

import '@comp/animate_title/animate_title'
import '@comp/animate_title/animate_title.scss'

import './style.scss'
import CONFIG from '@/scripts/config'
import { trackSection } from '@/scripts/ga'

$(() => {
    trackSection('Eco System')

    let ecosystemHtml = ''

    $.ajax({
        type: 'GET',
        url: `${CONFIG.API_BASE}company`,
        dataType: 'json',
        success: function (msg) {
            if (msg.message) {
                location.href = '404.html'
                return
            }

            msg.forEach(r => {
                let item = {
                    bgUrl: r.cover,
                    iconUrl: r.logo,
                    title: r.name,
                    link: `ecosystem_detail.html?id=${r.id}`
                }
                ecosystemHtml += `
                    <div class="col-xs-12 col-sm-6 item-wrap">
                        <a href="${item.link}" class="ext partener-card-wrap track-btn" style="display: block" data-track="Partner #${item.title}">
                            <div class="partener-img-wrap tilt-link" style="background-image: url('${item.bgUrl}')"></div>
                            <div class="partener-label-wrap left">
                            <div class="icon" style="background-image: url('${item.iconUrl}')"></div>
                            <h6 class="title">${item.title}</h6>
                            </div>
                        </a>
                    </div>
                `
            })

            $('#ecosystem-list-wrap').html(ecosystemHtml)

            VanillaTilt.init(document.querySelectorAll('.tilt-link'), {
                max: 2,
                speed: 600
            })

            scrollbar.init()
        },
        error: function (err) {
            console.log('err', err)
            location.href = '404.html'
        }
    })

    $('.bottom-link-wrap').click(function () {
        location.href = 'apply.html'
    })
})
